/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Link, useLocation  } from 'react-router-dom';

// project imports
import store from 'features/store';
import { secret_key, taxexemptionpending, bidsSseEvent, taxExemptCount, messageCount } from 'shared/settings/apiconfig';
import axios from 'axios';
import { getSellerHeaders, getSellerUrl, getBuyerHeaders, getBuyerUrl,getTaxUrl } from 'shared/http';
 
import moment from 'moment';

// style imports
import './Sidebar.scss';

/**
 * defines sidebar once login is made
 * 
 * @param props
 * 
 * @returns html code to render sidebar code
 * 
**/

export class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            buyerToken: '',
            PendingCount: 0,
            unreadCount: '',
            readCount: '',
            deleteCount: '',
            replyCount: '',
            itemid : this.props?.location?.itemId ?  this.props.location.itemId : this.props?.location?.state?.messageViewitemId ? this.props?.location?.state?.messageViewitemId : ''
        };
        
    }

    componentDidMount() {
        this.getBuyerToken();
        this.getMessageCount();
        this.buyerList = [];
        
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.taxExemptionPendingList !== this.props.taxExemptionPendingList) {           
            this.getPendingCount();    
        }
        const currentPath = this.props.location?.pathname;
        const prevPath = prevProps.location?.pathname;
      
        // Run only if path changed
        // if (currentPath !== prevPath) {
        //   if (currentPath?.includes('messages')) {
        //     this.setState({ itemid: '' }, () => {
        //         this.getMessageCount(); 
        //       });
            
        //   }
        // }
      }

    // get Buyer Token Call
    async getBuyerToken() {
        await axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.setState({
                    buyerToken: response.data.accessToken,
                }, async () => {
                    await this.getPendingCount();
                    await this.sseEventListener();
                });
            }
        }).catch(error => {
        });
    }
    /* SSE Event  */
    sseEventListener = () => {
        try {
            let now = moment().format('DD-MM-YYYY-HH-mm-ss');
            now = now ? now.replace(/-/g, '') : Math.floor(100000 + Math.random() * 900000);
            const number = Math.floor(100000 + Math.random() * 900000);
            const clientId = now + number.toString();
            this.eventSource = new EventSource(`${getTaxUrl(bidsSseEvent)}${clientId}`);
            this.eventSource.onmessage = (event) => this.updateNotification(event, clientId);
            this.eventSource.onerror = (event) => console.clear();
        } catch (e) {
        }
    }

    updateNotification = (event, clientId) => {
        try {

            const data = JSON.parse(event.data);
            const res = data?.buyerId ? data : JSON.parse(data);
            if (res.status === "connected") {
                axios.get(getTaxUrl(`${taxExemptCount}${clientId}`), getSellerHeaders()).then(response => {
                    if (response.data.status.toLowerCase() === 'success') {
                    }
                }).catch(error => {
                });
            } else {
                if (res?.buyerId) {
                    this.buyerList.push(res.buyerId);
                    this.stateUpdate();
                }
            }
        } catch (e) {
        }
    }

    getPendingCount() {
        let userLocations = this.props?.user?.activelocationid?.filter(x => !!x);
        let field = ["id"];
        let filter = [
            { field: "locationid", value: userLocations, op: "IN", join: "AND" },
            { field: "isDeleted", value: 0, op: "=", join: "AND" },
            { field: "active", value: 1, op: "=", join: "AND" },
            { field: "shipping", value : 1, op:"=", join: "AND" }
        ];
        let Payload = {
            "field": field,
            "filter": filter
        };
        this.buyerList = [];
        axios.post(getBuyerUrl(`${taxexemptionpending}`, {}), JSON.stringify(Payload), getBuyerHeaders(this.state.buyerToken))
            .then((response) => {
                if (response?.data?.data) {
                    let data = response?.data?.data;
                    data.forEach(item => {
                        this.buyerList.push(item.id);
                    });                    
                                
                    this.setState({
                        PendingCount: new Set(response?.data?.data).size
                    });
                    
                }
            })
            .catch((error) => {
            });
    }
    stateUpdate(){
        this.setState({
            PendingCount: new Set(this.buyerList).size
        },()=>{
            this.refreshPage();
        })
    }
    refreshPage(){ 
        if(this.state.PendingCount > 0 && window.location.pathname == '/buyer/pending-tax-exemption')
        {
           // store.dispatch({ type: 'SET_REFRESH_PENDING_LIST', payload: true });
            this.props.history.push(`/buyer`); 
        }
    }
    onLogoutUser = () => {
        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: true });
    };

    getMessageCount() {
        let filter = [];
        if ( this.state.itemid ) {
            filter.push({
                field: "itemid",
                value: parseInt(this.state.itemid),
                op: "=",
                join: "AND"
            });
        }
        let payload = {
            "filter": filter
        };
        axios.post(getSellerUrl(messageCount), JSON.stringify(payload), getSellerHeaders()).then((response) => {
            if (response?.data?.data) {
                let data = response?.data?.data;
                this.setState({
                    unreadCount: data.unreadCount,
                    readCount: data.readCount,
                    deleteCount: data.deleteCount,
                    replyCount: data.replyCount
                });
            }
        }).catch((error) => {
        });
    }

    render() {

        return (
            <div className="d-flex flex-column sidebar-box">
                <div className="d-flex d-lg-none flex-row align-items-center justify-content-between sidebar-tools">
                    <div className="d-flex flex-row">
                        <div className="d-flex flex-row profile-border-outer">
                            <div className="profile-border-inner">
                                <img src={this.props['user']['profileImage'] ? this.props['user']['profileImage'] : (process.env.PUBLIC_URL + '/static/icons/profile/default_1.svg')} alt="profile" height="28" width="26" className="profile" />
                            </div>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <b>{`${this.props['user']['lastName']}, ${this.props['user']['firstName']}`}</b>
                        </div>
                    </div>
                </div>
                <ul className="d-flex flex-column menu-list">
                    <li>
                        <div className={`d-flex home-item flex-column ${this.props.location.pathname === '/home' ? 'menu-item-active' : ''}`}>
                            <Link to="/home">
                                <div className="d-flex flex-row menu-item">
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Home.svg`} alt="home" height="40px" width="40px" />
                                    <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                        <span>Home</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </li>
                    {
                        this.props.user.role && this.props.user.role.includes('Administrator') ?
                            <li>
                                <div className={`d-flex flex-column ${this.props.location.pathname.includes('/locations') ? 'active-item' : ''}`}>
                                    <Link to="/locations">
                                        <div className={`d-flex flex-row menu-item ${this.props.location.pathname === '/locations' ? 'menu-item-active' : ''}`} style={{ margin: '4px 0' }}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Locations.svg`} alt="locations" height="40px" width="40px" />
                                            <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                                <span>Locations</span>
                                                {
                                                    this.props.location.pathname.includes('/locations') ?
                                                        <i className="fa fa-chevron-down menu-item-expandable"></i> :
                                                        <i className="fa fa-chevron-right menu-item-expandable"></i>
                                                }
                                            </div>
                                        </div>
                                    </Link>
                                    <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                                        <Link to="/locations/images" className={`sub-menu-item ${this.props.location.pathname.includes('/locations/images') ? 'sub-menu-active' : ''}`}>
                                            <div className={`d-flex flex-row`}>
                                                <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                                    <i className="fa fa-chevron-right"></i>
                                                </div>
                                                <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                                    <span>Location Images</span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to="/locations/staff-agents" className={`sub-menu-item ${this.props.location.pathname.includes('/locations/staff-agents') ? 'sub-menu-active' : ''}`}>
                                            <div className={`d-flex flex-row`}>
                                                <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                                    <i className="fa fa-chevron-right"></i>
                                                </div>
                                                <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                                    <span>Staff & Agents</span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to="/locations/templates" className={`sub-menu-item ${this.props.location.pathname.includes('/locations/templates') ? 'sub-menu-active' : ''}`}>
                                            <div className={`d-flex flex-row`}>
                                                <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                                    <i className="fa fa-chevron-right"></i>
                                                </div>
                                                <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                                    <span>Location Templates</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </li> :
                            null
                    }
                    {
                        this.props.user.role && (this.props.user.role.includes('Administrator') || this.props.user.role.includes('Staff')) ?
                            <li>
                                <div className={`d-flex flex-column ${this.props.location.pathname.includes('/sales') ? 'active-item' : ''}`} style={{ margin: '4px 0' }}>
                                    <Link to="/sales">
                                        <div className={`d-flex flex-row menu-item ${this.props.location.pathname === '/sales' ? 'menu-item-active' : ''}`}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Sales.svg`} alt="sales" height="40px" width="40px" />
                                            <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                                <span>Sales</span>
                                                {
                                                    this.props.location.pathname.includes('/sales') ?
                                                        <i className="fa fa-chevron-down menu-item-expandable"></i> :
                                                        <i className="fa fa-chevron-right menu-item-expandable"></i>
                                                }
                                            </div>
                                        </div>
                                    </Link>
                                    <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                                        <Link to="/sales/items" className={`sub-menu-item ${this.props.location.pathname.includes('/sales/items') ? 'sub-menu-active' : ''}`} style={{ margin: '4px 0' }}>
                                            <div className={`d-flex flex-row`}>
                                                <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                                    <i className="fa fa-chevron-right"></i>
                                                </div>
                                                <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                                    <span>Items</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </li> :
                            null
                    }
                    {
                        this.props.user.role && !this.props.user.role.includes('Administrator') && !this.props.user.role.includes('Staff') ?
                            <li>
                                <div className={`d-flex flex-column ${this.props.location.pathname.includes('/sales/items') ? 'active-item' : ''}`}>
                                    <Link to="/sales/items">
                                        <div className={`d-flex flex-row menu-item ${this.props.location.pathname === '/sales/items' ? 'menu-item-active' : ''}`}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Agent_Items.svg`} alt="items" height="40px" width="40px" />
                                            <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                                <span>Items</span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </li> :
                            null
                    }
                    {
                        this.props.user.role && (this.props.user.role.includes('Administrator') || this.props.user.role.includes('Staff')) ?
                            <li>
                                <div className={`d-flex flex-column ${this.props.location.pathname.includes('/buyer') ? 'active-item' : ''}`} style={{ margin: '4px 0' }}>
                                    <Link to="/buyer">
                                        <div className={`d-flex flex-row menu-item ${this.props.location.pathname === '/buyer' ? 'menu-item-active' : ''}`}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Buyer.svg`} alt="buyer" height="40px" width="40px" />
                                            <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                                <span>Buyer/Bidder</span>
                                                {
                                                    this.props.location.pathname.includes('/buyer') ?
                                                        <i className="fa fa-chevron-down menu-item-expandable"></i> :
                                                        <i className="fa fa-chevron-right menu-item-expandable"></i>
                                                }
                                            </div>
                                        </div>
                                    </Link>
                                    <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                                        <Link to="/buyer/pending-tax-exemption" className={`sub-menu-item ${this.props.location.pathname.includes('/buyer/pending-tax-exemption') ? 'sub-menu-active' : ''}`}>
                                            <div className={`d-flex flex-row`}>
                                                <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                                    <i className="fa fa-chevron-right"></i>
                                                </div>
                                                <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                                   
                                                    <span>Approve Tax Exemption {`(${this.state.PendingCount>0 ? this.state.PendingCount : 0 })`} </span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                {/* <div className={`d-flex flex-column ${this.props.location.pathname.includes('/buyer') ? 'menu-item-active' : ''}`}>
                                    <Link to="/buyer">
                                        <div className="d-flex flex-row menu-item">
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Buyer.svg`} alt="buyer" height="40px" width="40px" />
                                            <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                                <span>Buyer</span>
                                            </div>
                                        </div>
                                    </Link>
                                </div> */}
                            </li> :
                            null
                    }
                    { 
                    this.props.user.role && (this.props.user.role.includes('Administrator') || this.props.user.role.includes('Staff')) ?
                    <li>
                        <div className={`d-flex flex-column ${this.props.location.pathname.includes('/invoice') ? 'menu-item-active' : ''}`} style={{ margin: '4px 0' }}>
                            <Link to="/invoice">
                                <div className="d-flex flex-row menu-item">
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Invoice.svg`} alt="invoice" height="40px" width="40px" />
                                    <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                        <span>Invoice</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </li> : null 
                    }
                    { 
                    this.props.user.role && (this.props.user.role.includes('Administrator') || this.props.user.role.includes('Staff')) ?
                    <li>
                        <div className={`d-flex flex-column ${this.props.location.pathname.includes('/reports') ? 'active-item' : ''}`} style={{ margin: '4px 0' }}>
                            <Link to="/reports/reportsalesitem">
                                <div className={`d-flex flex-row menu-item ${this.props.location.pathname === '/reports' ? 'menu-item-active' : ''}`}>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Reports.svg`} alt="reports" height="40px" width="40px" />
                                    <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                        <span>Reports</span>
                                        {
                                            this.props.location.pathname.includes('/reports') ?
                                                <i className="fa fa-chevron-down menu-item-expandable"></i> :
                                                <i className="fa fa-chevron-right menu-item-expandable"></i>
                                        }
                                    </div>
                                </div>
                            </Link>
                            <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                                <Link to="/reports/reportsalesitem" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/reportsalesitem') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Sale History Report</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/reports/reportbidder" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/reportbidder') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Bidder Report</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/reports/reportpickup" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/reportpickup') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Pickup Report</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/reports/salereport" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/salereport') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Active Sales Report</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/reports/reportitem" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/reportitem') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Sign Off Report</span>
                                        </div>
                                    </div>
                                </Link>
                                 { this.props.user.role && this.props.user.role.includes('Administrator') ?
                                <Link to="/reports/reportadmin" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/reportadmin') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Admin Report</span>
                                        </div>
                                    </div>
                                </Link> : " " } 
                                {/* Seller Reports Side Menu ------ Admin only */}
                                
                                {/* <Link to="/reports/reportseller" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/reportseller') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Seller Report</span>
                                        </div>
                                    </div>
                                </Link> */}

                                {/* <Link to="/reports/reportupcoming" className={`sub-menu-item ${this.props.location.pathname.includes('/reports/reportupcoming') ? 'sub-menu-active' : ''}`}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Upcoming Sales Report</span>
                                        </div>
                                    </div>
                                </Link> */}
                            </div>
                        </div>
                    </li> : null }
                    {
                    this.props.user.role && this.props.user.role.includes('Administrator') ?
                    <li>
                        <div className={`d-flex flex-column ${this.props.location.pathname.includes('/messages') ? 'active-item' : ''}`} style={{ margin: '4px 0' }}>
                            <Link to="/messages/unread">
                                <div className={`d-flex flex-row menu-item ${this.props.location.pathname === '/messages' ? 'menu-item-active' : ''}`}>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/Messages.svg`} alt="messages" height="40px" width="40px" />
                                    <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                        <span>Messages</span>
                                        {
                                            this.props.location.pathname.includes('/messages') ?
                                                <i className="fa fa-chevron-down menu-item-expandable"></i> :
                                                <i className="fa fa-chevron-right menu-item-expandable"></i>
                                        }
                                    </div>
                                </div>
                            </Link>
                            <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                                <Link to="/messages/unread" className={`sub-menu-item ${this.props.location.pathname.includes('/messages/unread') ? 'sub-menu-active' : ''}`} onClick={() => {this.getMessageCount()}}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Unread {`(${this.state.unreadCount ? this.state.unreadCount : 0 })`}</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/messages/read" className={`sub-menu-item ${this.props.location.pathname.includes('/messages/read') ? 'sub-menu-active' : ''}`} onClick={() => {this.getMessageCount()}}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Read {`(${this.state.readCount ? this.state.readCount : 0 })`}</span>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/messages/replied" className={`sub-menu-item ${this.props.location.pathname.includes('/messages/replied') ? 'sub-menu-active' : ''}`} onClick={() => {this.getMessageCount()}}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Replied {`(${this.state.replyCount ? this.state.replyCount : 0 })`}</span>
                                        </div>
                                    </div>
                                </Link> 
                                <Link to="/messages/deleted" className={`sub-menu-item ${this.props.location.pathname.includes('/messages/deleted') ? 'sub-menu-active' : ''}`} onClick={() => {this.getMessageCount()}}>
                                    <div className={`d-flex flex-row`}>
                                        <div className="d-flex flex-column align-items-center justify-content-center sub-menu-item-icon">
                                            <i className="fa fa-chevron-right"></i>
                                        </div>
                                        <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                            <span>Deleted {`(${this.state.deleteCount ? this.state.deleteCount : 0 })`}</span>
                                        </div>
                                    </div>
                                </Link>                         
                            </div>
                        </div>
                    </li> : null }
                    <li>
                    <div className={`d-flex flex-column ${this.props.location.pathname.includes('/help-center') ? 'menu-item-active' : ''}`}>
                        <Link to="/help-center">
                            <div className="d-flex flex-row menu-item">
                                <div><span className='faq-icon'>?</span></div>
                                <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                    <span>Help Center</span>
                                </div>
                            </div>
                        </Link>
                    </div>
                    </li>
                    <li className="d-lg-none">
                        <div className="d-flex flex-row menu-item" onClick={this.onLogoutUser}>
                            <img src={`${process.env.PUBLIC_URL}/static/icons/header/logout.svg`} alt="logout" height="25px" width="25px" style={{ margin: '4px 8px' }} />
                            <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                <span>Sign Out</span>
                            </div>
                        </div>
                    </li> 
                </ul>
            </div>
        );
    }
}
